import {AccountType} from '../../../enums/account-type';
import {ExchangeAccountBase} from '../../../models/exchange-account';
import {NewOrder} from '../../../models/order';

export const getNewOrderParamsByAccountBase = (accountBase: ExchangeAccountBase): Partial<NewOrder> => ({
    accountId: accountBase && accountBase.id
});

export const getAccountBaseByNewOrderParams = (newOrder: Partial<NewOrder>): ExchangeAccountBase => ({
    id: newOrder.accountId,
    type: newOrder.leverage ? AccountType.MARGIN : AccountType.CASH
});
